import styled from 'styled-components';

export const AuthLoadingRoot = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100dvh;
  padding: calc(16px + var(--app-safe-area-top))
    calc(16px + var(--app-safe-area-right))
    calc(16px + var(--app-safe-area-bottom))
    calc(16px + var(--app-safe-area-left));
`;

export const AuthLoadingBackdrop = styled.button`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: rgba(39, 38, 43, 0.65);
  cursor: default;
`;

export const AuthLoadingCard = styled.div`
  position: relative;
  z-index: 1;
  width: min(364px, 100%);
  height: min(
    520px,
    calc(100dvh - 32px - var(--app-safe-area-top) - var(--app-safe-area-bottom))
  );
  overflow: hidden;
  border-radius: 12px;

  @media screen and (max-width: 768px),
    screen and (max-width: 1024px) and (orientation: landscape) {
    width: calc(100vw - var(--app-safe-area-left) - var(--app-safe-area-right));
    height: calc(
      100dvh - var(--app-safe-area-top) - var(--app-safe-area-bottom)
    );
    border-radius: 0;
  }
`;
